import Isotope from 'isotope-layout';
var jQueryBridget = require('jquery-bridget');

const $ = window.jQuery;

const wcProductCat = {

    readyFn: function () {
        let self = this;
        jQueryBridget('isotope', Isotope, $);
        self.isotopeInit();
    },

    isotopeInit: function () {
        var $grid = $('.isotope-products').isotope({
            itemSelector: '.isotope-product-item',
            //layoutMode: 'fitRows'
        });
        //$grid.isotope('layout');

        $('.filter-sub-cat').on('click', function () {
            $('.filter-product').removeClass('active');
            if ($(this).hasClass('active')) {
                // Si déjà actif, on désactive le filtre et affiche tout
                $(this).removeClass('active');
                $grid.isotope({ filter: '*' });
            } else {
                $('.filter-sub-cat').removeClass('active');
                $(this).addClass('active');
                $grid.isotope({ filter: $(this).data('filter') });
            }
            $('html, body').animate({
                scrollTop: $('section#products').offset().top - 150
            }, 500);
        });

        $('.filter-product').on('click', function () {
            $('.filter-sub-cat').removeClass('active');
            if ($(this).hasClass('active')) {
                // Si déjà actif, on désactive le filtre et affiche tout
                $(this).removeClass('active');
                $grid.isotope({ filter: '*' });
            } else {
                $('.filter-product').removeClass('active');
                $(this).addClass('active');
                $grid.isotope({ filter: $(this).data('filter') });
            }
            $('html, body').animate({
                scrollTop: $('section#products').offset().top - 150
            }, 500);
        });
    },

}

export { wcProductCat };